import { StatisticsData } from '@dreryk/egabinet-statistics-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { PageLoader } from '../../common/PageLoader';
import { useFindStatisticsData } from '../useFindStatisticsData.hook';

import { StatisticsPreviewTableEmptyStatePlaceholder } from './StatisticsPreviewTable';

type StatisticsPreviewLoaderRenderProps = {
   statisticsData: StatisticsData;
   refetchStatisticsData: VoidFunction;
};

type StatisticsPreviewLoaderProps = {
   readonly statisticsId: number;
   readonly children: (result: StatisticsPreviewLoaderRenderProps) => JSX.Element;
};

export const StatisticsPreviewLoader = (props: StatisticsPreviewLoaderProps): JSX.Element => {
   const {
      data: statisticsData,
      loading: statisticsDataLoading,
      error: statisticsDataError,
      refetch: refetchStatisticsData,
   } = useFindStatisticsData(props.statisticsId);

   if (statisticsDataLoading) {
      return <PageLoader />;
   }

   if (statisticsDataError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   if (!statisticsData) {
      return <StatisticsPreviewTableEmptyStatePlaceholder />;
   }

   return props.children({
      statisticsData: statisticsData,
      refetchStatisticsData: refetchStatisticsData,
   });
};
